import { render, staticRenderFns } from "./PaySchedules.vue?vue&type=template&id=bde40d40&scoped=true&"
import script from "./PaySchedules.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaySchedules.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PaySchedules.vue?vue&type=style&index=0&id=bde40d40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde40d40",
  null
  
)

export default component.exports